import React from "react";
import { GoDotFill } from "react-icons/go";

const ProductSideCard = ({ bulletPoints }) => {
  let data = bulletPoints;

  // console.log("bullet Points Data FS :", data);

  try {
    // Case 1: data is a stringified array
    if (typeof data === "string" && data.startsWith("[")) {
      data = JSON.parse(data);
    }

    // Case 2: data is an object with a single key "0" that contains a stringified array
    else if (
      typeof data === "object" &&
      data !== null &&
      typeof data["0"] === "string" &&
      data["0"].startsWith("[")
    ) {
      data = JSON.parse(data["0"]);
    }

    // Case 3: data is an object with bullet points as values like { "0": "point", "1": "point" }
    else if (typeof data === "object" && data !== null) {
      data = Object.values(data);
    }

    // Case 4: Already an array, do nothing
    else if (!Array.isArray(data)) {
      data = [];
    }
  } catch (e) {
    console.error("Error parsing bullet points:", e);
    data = [];
  }

  return (
    <div>
      {data.length > 0 ? (
        data.map((el, index) => (
          <ul className="my-0" key={index}>
            <li className="flex items-center py-3">
              <span className="text-xl text-gray-400 items-start mr-4">
                <GoDotFill />
              </span>
              <p className="font-sans leading-5 text-sm text-gray-500">{el}</p>
            </li>
          </ul>
        ))
      ) : (
        <p className="text-gray-400 text-sm">No bullet points available.</p>
      )}
    </div>
  );
};

export default ProductSideCard;
